exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".CirrusMEDIcon__icon__HTz5-{width:6.64286rem!important;height:1.14286rem!important}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/icons/src/components/controls/icons/CirrusMEDIcon.scss"],"names":[],"mappings":"AAEA,4BACE,2BAA2B,AAC3B,2BAA4B,CAC7B","file":"CirrusMEDIcon.scss","sourcesContent":["@import '../../../styles/theme.scss';\n\n.icon {\n  width: rem(93px) !important;\n  height: rem(16px) !important;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "CirrusMEDIcon__icon__HTz5-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/icons/CirrusMEDIcon.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/icons/CirrusMEDIcon.scss
// module chunks = 0